import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "col-12 col-sm-4 text-subtitle2 q-px-md" }
const _hoisted_2 = {
  key: 0,
  class: "col-12 col-sm-8 q-pt-sm q-pt-sm-none text-body2 q-px-md"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = ["innerHTML"]

import { PropType } from "vue";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'DataTable',
  props: {
    data: {
      type: Array as PropType<{ label: string, value: string, html?: boolean, badge?: boolean, badgeClass?: string }[]>,
      default: []
    }
  },
  setup(__props) {

  const props = __props

return (_ctx: any,_cache: any) => {
  const _component_q_badge = _resolveComponent("q-badge")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data, (item, index) => {
    return (_openBlock(), _createElementBlock("div", {
      class: _normalizeClass(["row q-py-md", index === __props.data.length-1 ? '' : 'border-bottom']),
      key: item.label + index
    }, [
      _createElementVNode("div", _hoisted_1, _toDisplayString(item.label), 1),
      (!item.html)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (item.badge)
              ? (_openBlock(), _createBlock(_component_q_badge, {
                  key: 0,
                  class: _normalizeClass([item.badgeClass, "text-overline text-uppercase"])
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.value), 1)
                  ]),
                  _: 2
                }, 1032, ["class"]))
              : _createCommentVNode("", true),
            (!item.badge)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(item.value), 1))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", {
            key: 1,
            innerHTML: item.value,
            class: "col-12 col-sm-8 q-pt-sm q-pt-sm-none text-body2 q-px-md"
          }, null, 8, _hoisted_4))
    ], 2))
  }), 128))
}
}

})